import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { verifyAccessToken } from "@/lib/bellomy-auth";
import { getAccessToken, safeReturnTo } from "@/lib/session";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    if (!getAccessToken()) throw redirect({ to: "/login", search: { next: safeReturnTo(location.href) } });
    try { return { user: (await verifyAccessToken()).user }; }
    catch { throw redirect({ to: "/login", search: { next: safeReturnTo(location.href), error: "session" } }); }
  },
  component: () => <Outlet />,
});
